// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ot-1";
export var messageSideRight = "_ot-2";
export var subscribeToBackInStockBubbleContainer = "_ot-0";